export default {
  apiKey: "AIzaSyDi108tJqykuO9THGDnCKvJgrRJpohuDfo",
  authDomain: "abnrecipe.firebaseapp.com",
  databaseURL: "https://abnrecipe.firebaseio.com",
  projectId: "abnrecipe",
  storageBucket: "gs://abnrecipe.appspot.com/",
  messagingSenderId: "1025678886368",
  appId: "1:1025678886368:web:5dcbdeb553d91a80505785",
  measurementId: "G-3WZJ8TDB7X"
};
